export default {
  error: undefined,
  games: undefined,
  entries: undefined,
  selectedEntry: undefined,
  events: undefined,
  currentGameId: undefined, // Game in play or with nextGame = true
  selectedGameId: undefined, // Selected game in the slider
  revealAnimationInProgress: false,
  prize: undefined,
  loadingDataForGame: false,
  loadingDataForHeader: false,
  hidePrize: false,
  bonusCards: undefined,
  pageFullyLoaded: false
};
